module.exports = __webpack_public_path__ + "img/simplepay-logo-cards.511ac762.png";